import React from 'react';
import * as yup from 'yup';
import { SxStyle } from '../../../../../types';
import { useStringsContext } from '../../../../../contexts/strings';
import AccordionWrapper from '../accordion';
import svStrings from '../../../../../sv-strings';
import TextInputWithValidate, {
  InputWithValidateProps,
} from '../../../../common/input/text-input-with-validate';
import { PushNotificationValues } from '../../push-notification-send';
import Stack from '@mui/material/Stack';
import { PushNotification } from '../../../../../types/notification';
import Typography from '@mui/material/Typography';
import ImageWithValidate from '../../../../common/input/image-with-validate';

const titleValidation = yup.string().required(svStrings.validations.isRequired);
const messageValidation = yup.string().required(svStrings.validations.isRequired);

const styles: SxStyle = {
  container: {
    paddingLeft: '15px',
    paddingRight: '15px',
    paddingBottom: '24px',
  },
};

interface Props extends InputWithValidateProps<PushNotification> {
  expanded: boolean;
  pushNotification: PushNotificationValues;
}

const PushNotificationContent = ({
  expanded,
  pushNotification,
  onValue,
  onValidation,
  hideValidationError,
}: Props) => {
  const { strings } = useStringsContext();

  return (
    <AccordionWrapper expanded={expanded} name={strings.pushFields.titleContent}>
      <Stack spacing={3} sx={styles.container}>
        <TextInputWithValidate<PushNotification>
          name="title"
          label={strings.pushFields.contentTitle}
          value={pushNotification?.title}
          validation={titleValidation}
          onValue={onValue}
          onValidation={onValidation}
          hideValidationError={hideValidationError}
        />
        <TextInputWithValidate<PushNotification>
          name="description"
          label={strings.pushFields.contentMessage}
          value={pushNotification?.title}
          validation={messageValidation}
          onValue={onValue}
          onValidation={onValidation}
          multiline
          rows={3}
          hideValidationError={hideValidationError}
        />
        <Stack>
          <Typography variant="body2-bold">
            {strings.pushNotifications.contentImageTitle}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            {strings.pushNotifications.contentImageLabel}
          </Typography>
        </Stack>
        <ImageWithValidate<PushNotification>
          name="image"
          storagePath={`pushNotifications/images`}
          onValue={onValue}
          onValidation={onValidation}
          value={pushNotification.image || ''}
          validation={yup.string().url(svStrings.validations.validImage).nullable(true)}
          recommendedHeight={640}
          recommendedWidth={540}
        />
      </Stack>
    </AccordionWrapper>
  );
};

export default PushNotificationContent;
